import { Link } from '@reach/router';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './BackButton.module.scss';

function BackButton({ caption, path, onClick }) {
  const { t } = useTranslation();
  return (
    <div className={styles.backButton}>
      <Link to={process.env.REACT_APP_BASE_PATH} className={styles.backArrow} />
      <div className={styles.tooltipText}>{t('Back')}</div>
      <div className={styles.breadcrumbsContainer}>
        {
          path.map((p, i) => (
            <React.Fragment key={p}>
              <span
                onClick={onClick.bind(null, i)}
                onKeyPress={() => {}}
                role="link"
                tabIndex="-1"
                className={styles.breadcrumb}
              >
                {p}
              </span>
              <span className={styles.breadcrumbSeparator}>/</span>
            </React.Fragment>
          ))
        }
        <span className={styles.caption}>
          {caption}
        </span>
      </div>
    </div>
  );
}

BackButton.propTypes = {
  caption: PropTypes.string.isRequired,
  path: PropTypes.instanceOf(Array),
  onClick: PropTypes.func,
};

BackButton.defaultProps = {
  path: [],
  onClick: () => {},
};

export default BackButton;
